import { Route, Routes } from '@angular/router';
import { EmptyComponent } from './tabs/component/empty/empty.component';
import {
  addContextToUrlRedirect,
  fetchContextAndEnsureCorrectness,
  preventBackNavigation,
  replaceMeWithContextIdOrLogin,
  showLoginErrorsGuards,
} from './core/security/guard/auth.guard';
import { LogoutPage } from './authentication/logout-page/logout.page';
import { UpgradePage } from './versioning/page/upgrade-page/upgrade.page';
import { isNativeAppGuard } from './core/security/guard/native.guard';
import { uitnodigingRoutes } from './uitnodiging/routes';
import { startRoutes } from './start/routes';
import { tabsRoutes } from './tabs/routes';
import { NotFoundPage } from './shared/page/not-found-page/not-found.page';
import { dirtyFormGuard } from './shared/components/dirty-form-guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: EmptyComponent,
    canActivate: [addContextToUrlRedirect],
  },
  {
    path: 'failed',
    canActivate: [showLoginErrorsGuards],
    component: EmptyComponent,
  },
  {
    path: 'app/logout',
    title: 'Logout',
    component: LogoutPage,
  },
  {
    path: 'app/upgrade',
    pathMatch: 'full',
    title: 'Upgrade',
    component: UpgradePage,
    canActivate: [isNativeAppGuard],
    canDeactivate: [() => false],
    data: { sidebarVisible: false },
  },
  {
    path: 'app/uitgenodigd',
    children: uitnodigingRoutes,
    data: { sidebarVisible: false },
  },
  {
    path: 'app/me',
    children: [
      {
        path: '**',
        component: EmptyComponent,
        canActivate: [replaceMeWithContextIdOrLogin],
      },
    ],
  },
  {
    path: 'app/block-back-navigation',
    component: EmptyComponent,
    canActivate: [preventBackNavigation],
  },
  {
    path: 'app/start',
    children: startRoutes,
    data: { sidebarVisible: false },
  },
  {
    path: 'app/:contextId',
    children: tabsRoutes,
    canMatch: [fetchContextAndEnsureCorrectness],
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundPage,
    data: { sidebarVisible: false },
  },
];

function applyToAllChildRoutes(routes: Routes, applyFn: (route: Route) => Route): Routes {
  return routes.map((route) => {
    if (route.children) {
      return { ...route, children: applyToAllChildRoutes(route.children, applyFn) };
    } else {
      return applyFn(route);
    }
  });
}

export const finalRoutes = applyToAllChildRoutes(routes, (route) => {
  return {
    ...route,
    canDeactivate: [...(route.canDeactivate ?? []), dirtyFormGuard],
  };
});
